export default __webpack_public_path__ + "static/media/data logger.84b08a88.jpg";